import { useContext } from "react";
import Button from "../Button/Button";
import "./GameInstructions.scss";
import { useNavigate } from "react-router";
import UserContext from "../../context/UserContext";
const GameInstructions = ({ game }) => {
  const { user } = useContext(UserContext);

  const swingInstructionJSX = (
    <ul className="game-instructions__list">
      <li>
        A phoneme will appear on the screen and {user.childName} will have to
        say the sound of the phoneme shown
      </li>
      <li>
        If the sound is said correctly, click the green button at the bottom
        right of the screen
      </li>
      <li>
        If the sound is not said correctly, click the red button at the bottom
        right of the screen
      </li>
      <li>
        {user.childName} will have 1 minute to say as many correct sounds as
        possible
      </li>
      <li>
        If {user.childName} needs help, click the squirrel to hear the sound
      </li>
    </ul>
  );

  const blendingInstructionJSX = (
    <ul className="game-instructions__list">
      <li>
        A word will appear on the screen and {user.childName} will have to say
        the sound of the word shown
      </li>
      <li>
        Click on parts of the word to highlight the phenomes that the word is
        made up of so that {user.childName} can sound each phenome before saying
        the word
      </li>
      <li>
        If the sound is said correctly, click the green button at the bottom
        right of the screen
      </li>
      <li>
        If the sound is not said correctly, click the red button at the bottom
        right of the screen
      </li>
      <li>{user.childName} will have three words to rehearse through</li>
    </ul>
  );

  let text = "";
  switch (game) {
    case "swing":
      text = swingInstructionJSX;
      break;
    case "blending":
      text = blendingInstructionJSX;
      break;
  }

  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/${game}-game`);
  };

  return (
    <div className="game-instructions">
      <h1 className="game-instructions__heading">HOW TO PLAY</h1>
      {text}
      <Button label={"LET'S PLAY"} onClick={handleClick} />
    </div>
  );
};

export default GameInstructions;
